module.exports = __webpack_public_path__ + "static/media/texture (15).1e4adf3f.jpg";